import i from './assign-base.container';

export default i;
